import type { CirclesNavIconVariant } from './CirclesNavEntry'

export interface CirclesIconVariantInputs {
  /** HeaderV2's dark-mode state (solid dark or transparent-over-hero ≥768px). */
  darkMode: boolean
  /** Member-home first-touch header visible. */
  firstTouch: boolean
  /** First-touch hero color scheme (`'dark'` / `'light'` / absent). */
  firstTouchColorScheme: string | null | undefined
}

/**
 * HeaderV2 color state → monochrome circles-mark variant. The mark is a PNG
 * (no `currentColor` tint), so the header picks the asset per state: `white`
 * wherever the header has color behind it (dark-mode incl.
 * transparent-over-hero, first-touch over a dark hero), `black` on the solid
 * white header and first-touch over a light hero. Pure so the truth table is
 * unit-testable without mounting HeaderV2.
 */
export default function getCirclesIconVariant ({
  darkMode,
  firstTouch,
  firstTouchColorScheme,
}: CirclesIconVariantInputs): CirclesNavIconVariant {
  return (darkMode && !firstTouch) || (firstTouch && firstTouchColorScheme === 'dark')
    ? 'white'
    : 'black'
}
